exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".formDelOrg .del-warning {\n  padding-bottom: 20px; }\n\n.formDelOrg .form-block {\n  margin-top: 0px; }\n\n.formDelOrg .form-action {\n  float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/delete-policy/delete-policy.scss
// module id = Y1Z4
// module chunks = 0